// import Login from '../views/webLogin/Login';
import LoginV3 from '../views/webLogin/LoginV3';

export default [
  {
    path: '/',
    name: '',
    component: LoginV3,
  },
];
